var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.started)?_c('AxArtboardUploadsProgress',{key:_vm.batch.id,attrs:{"batch":_vm.batch},on:{"close":function($event){return _vm.dismissBatch(_vm.batch.id)}}}):_vm._e(),_c('AxArtboardUploadsPicker'),(_vm.isElectron)?_c('AxArtboardUploadsDesktopTracker'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }